module.exports = __webpack_public_path__ + "img/WhatsappIcon.2a2cd70.svg";